module.exports = {
    methods: {
        asset(path) {
            return window.Laravel.base_url + '/' + path;
        }
    }
}
